import { Home, Login, SignUp, ResetPassword, ForgotPasswordByUserName, ResetPasswordByEmail, SignUpByEmail, ServiceHistory, ScheduledService, Messages, ServiceRating, MaintenanceHowTo, Procare, Details, CreateProcare, RatingDetail, RequestRepairServiceCategory, RequestRepairServiceType, RequestRepairServiceCode, RequestRepairDetail, RequestConfirmation, RepairSuccess, ContactUs, UserProfile, RatingCompleted, RatingFailed, RatingSuccess, VideoList, VideoDetail, GuideList, GuideDetail, PrivacyStatement, UsePolicy, TextTerms, Agreement, EmailToSchedule, EmailToScheduleSuccess, ResidentEmailToSchedule, ResidentEmailScheduleSuccess, ProposedTimwForWO, WORatingDetail, Download, AiRequestRepairServiceCategory, CompleteAccount, ResetPasswordInfo, CheckLogin, SSOLoginError, RefreshPage, HPALoginError, AppSsoSuccess, VerifyEmail, SignInOneTimeCode, } from "@router/scenes/index";
import TokenExpiredPage from "@router/scenes/emailToSchedule/tokenExpired";
import UnableSchedulePage from "@router/scenes/emailToSchedule/unschedule";
import SendOTP from "@router/scenes/otpLogin/sendOtp";
import VerifyLocation from "@router/scenes/otpLogin/verifyByLocation";
import VerifyOTP from "@router/scenes/otpLogin/verifyOtp";
import OTPVerifyError from "@router/scenes/otpLogin/otpVerifyError";
import NoTechnicianPage from "@router/scenes/emailToSchedule/noTechnician";
import TimeApproachingPage from "@router/scenes/emailToSchedule/timeApproaching";
// Imported directly like the other anonymous pages: withWrap needs a logged-in user.
import SuperintendentBookingPage from "@router/scenes/superintendentBooking";
export var mainRouterList = [
    {
        title: "Dashboard",
        path: "/",
        component: Home
    },
    {
        title: "Service History",
        path: "/serviceHistory",
        component: ServiceHistory,
        titleBar: 'Service History',
        isShowBack: false,
    },
    {
        title: "Scheduled Service",
        path: "/scheduledService",
        component: ScheduledService,
        titleBar: 'Scheduled Service',
        isShowBack: false,
    },
    {
        title: "Messages",
        path: "/messages",
        component: Messages,
        titleBar: 'Messages',
        isShowBack: false,
    },
    {
        title: "ProCare",
        path: "/Procare",
        component: Procare,
        titleBar: 'ProCare Fridge List',
        isShowBack: true
    },
    {
        title: "Add Fridge List Item",
        path: "/CreateProcare",
        component: CreateProcare,
        titleBar: 'Add ProCare Fridge List',
        isShowBack: true
    },
    {
        title: "Service Rating",
        path: "/serviceRating",
        component: ServiceRating,
        titleBar: 'Service Rating',
        isShowBack: false,
    },
    {
        title: "Service Rating",
        path: "/rating/:id/:linkObjectType",
        component: RatingDetail,
        isShowBack: true,
        titleBar: 'Service Rating',
    },
    {
        title: "Service Rating",
        path: "/rating/success/:id/:linkObjectType",
        component: RatingSuccess,
        isShowBack: true,
        titleBar: 'Result',
    },
    {
        title: "Service Rating",
        path: "/rating/failed/:id/:linkObjectType",
        component: RatingFailed,
        isShowBack: true,
        titleBar: 'Result',
    },
    {
        title: "Service Rating",
        path: "/rating/completed/:id/:linkObjectType",
        component: RatingCompleted,
        isShowBack: false,
        titleBar: 'Service Rating',
    },
    {
        title: "Service Rating",
        path: "/woRating/:id/:linkObjectType",
        component: WORatingDetail,
        isShowBack: false,
        titleBar: '',
    },
    {
        title: "Maintenance How To",
        path: "/maintenanceHowTo",
        component: MaintenanceHowTo,
        titleBar: 'Maintenance How To',
    },
    {
        title: "Details",
        path: "/details/:id",
        component: Details
    },
    {
        title: "Service Category",
        path: "/requestRepair",
        component: RequestRepairServiceCategory,
        titleBar: 'Service Category',
    },
    {
        title: "Service Category",
        path: "/aiRequestRepair",
        component: AiRequestRepairServiceCategory,
        titleBar: 'Service Category',
    },
    {
        title: "Service Type",
        path: "/requestRepair/:serviceCategoryId/RequestRepairStep1",
        component: RequestRepairServiceType,
        titleBar: 'Service Type',
        isShowBack: true,
    },
    {
        title: "Service Code",
        path: "/requestRepair/:serviceCategoryId/:serviceTypeId/RequestRepairStep2",
        component: RequestRepairServiceCode,
        titleBar: 'Service Code',
        isShowBack: true,
    },
    {
        title: "Request Repair Detail",
        path: "/requestRepair/:serviceCategoryId/:serviceTypeId/:serviceCodeId/RequestRepairStep3",
        component: RequestRepairDetail,
        isShowBack: true,
    },
    {
        title: "Request Confirmation",
        path: "/requestRepair/:serviceCategoryId/:serviceTypeId/:serviceCodeId/RequestConfirmation",
        component: RequestConfirmation,
        isShowBack: true,
    },
    {
        title: "Creating Success",
        path: "/requestRepair/:serviceCategoryId/:serviceTypeId/:serviceCodeId/CreateWoSuccess",
        component: RepairSuccess,
        titleBar: 'Creating Success',
        isShowBack: true,
    },
    {
        title: "Contact Us",
        path: "/contactUs",
        component: ContactUs,
        titleBar: 'Contact Us'
    },
    {
        title: "Settings",
        path: "/Settings",
        component: UserProfile,
        titleBar: 'Settings',
        isShowBack: true,
    },
    {
        title: "Videos",
        path: "/videoList",
        component: VideoList,
        titleBar: 'Video List',
    },
    {
        title: "VideoDetail",
        path: "/videoDetail/:idx",
        component: VideoDetail,
        titleBar: 'Video',
        isShowBack: true,
    },
    {
        title: "Guides",
        path: "/guideList",
        component: GuideList,
        titleBar: "Guide List"
    },
    {
        title: "GuideDetail",
        path: "/guideDetail/:idx",
        component: GuideDetail,
        titleBar: 'Guide',
        isShowBack: true,
    },
    {
        title: "The Privacy Statement",
        path: "/UserTerms/PrivacyStatement",
        component: PrivacyStatement,
        titleBar: "THE PRIVACY STATEMENT",
        isHideToggler: true
    },
    {
        title: "Acceptable Use Policy",
        path: "/UserTerms/UsePolicy",
        component: UsePolicy,
        titleBar: "ACCEPTABLE USE POLICY",
        isHideToggler: true
    },
    {
        title: "Text Terms",
        path: "/UserTerms/TextTerms",
        component: TextTerms,
        titleBar: "TEXT TERMS",
        isHideToggler: true
    },
    {
        title: "Agreement",
        path: "/agreement",
        component: Agreement,
        titleBar: "Agreement",
        isShowBack: true
    },
    {
        title: "EmailToSchedule",
        path: "/emailToSchedule",
        component: EmailToSchedule,
        titleBar: 'Email To Schedule',
        isHideToggler: true
    },
    {
        title: "EmailToScheduleSuccess",
        path: "/emailToSchedule/success",
        component: EmailToScheduleSuccess,
        isHideToggler: true
    },
    {
        title: "EmailToSchedule",
        path: "/ResidentScheduleOptimization/EmailToSchedule",
        component: ResidentEmailToSchedule,
        titleBar: 'Email To Schedule',
        isHideToggler: true
    },
    {
        title: "ResidentEmailScheduleSuccess",
        path: "/ResidentScheduleOptimization/EmailToSchedule/success",
        component: ResidentEmailScheduleSuccess,
        isHideToggler: true
    },
    {
        title: "ProposedTimeForWO",
        path: "/proposedTimeForWO",
        component: ProposedTimwForWO,
        isHideHeader: true
    },
    {
        title: "Download",
        path: "/download",
        component: Download,
        isHideHeader: false
    },
    {
        title: "Complete Account",
        path: "/completeAccount",
        component: CompleteAccount,
    },
];
export var loginRouterList = [
    {
        title: "Sign In",
        path: "/account/login",
        component: Login
    },
    {
        title: "Sign Up",
        path: "/account/signup",
        component: SignUp
    },
    {
        title: "Sign Up",
        path: "/account/signUpByEmail",
        component: SignUpByEmail
    },
    {
        title: "Reset Password",
        path: "/account/resetPasswordByEmail",
        component: ResetPasswordByEmail
    },
    {
        title: "Reset Password",
        path: "/account/resetpassword",
        component: ResetPassword
    },
    {
        // Target of the legacy /DRSP/RetrievePassword/PageRecoverpwd; not linked from anywhere else.
        title: "Reset Password",
        path: "/account/forgotPasswordByUserName",
        component: ForgotPasswordByUserName
    },
    {
        title: "Sign In One Time Code",
        path: "/account/signInOneTimeCode",
        component: SignInOneTimeCode
    },
    {
        title: "Verfiy OTP",
        path: "/account/sendOTP",
        component: SendOTP
    },
    {
        title: "Verfiy OTP",
        path: "/account/verifyOTP",
        component: VerifyOTP
    },
    {
        title: "Verfiy Location",
        path: "/account/verifyLocation",
        component: VerifyLocation
    },
    {
        title: "Verify OTP Error",
        path: "/account/verifyOtpError",
        component: OTPVerifyError
    },
    {
        title: "Verify Email",
        path: "/account/verifyEmail",
        component: VerifyEmail,
    },
    {
        title: "Reset Password Info",
        path: "/account/resetPasswordInfo",
        component: ResetPasswordInfo,
    },
    {
        title: "Sign In",
        path: "/account/checkLogin",
        component: CheckLogin,
    },
    {
        title: "Sign In Error",
        path: "/account/ssoError",
        component: SSOLoginError,
    },
    {
        title: "Security Verification",
        path: "/account/refreshPage",
        component: RefreshPage,
    },
    {
        title: "Sign In Error",
        path: "/account/hpaError",
        component: HPALoginError,
    },
    {
        title: "Sign In",
        path: "/account/appSsoSuccess",
        component: AppSsoSuccess,
    },
];
export var allowAnonymousList = [
    {
        title: "Link Expired",
        path: "/emailToSchedule/tokenExpired",
        component: TokenExpiredPage
    },
    {
        title: "Link Expired",
        path: "/ResidentScheduleOptimization/EmailToSchedule/tokenExpired",
        component: TokenExpiredPage
    },
    {
        title: "Unable To Schedule",
        path: "/ResidentScheduleOptimization/EmailToSchedule/unableSchedule",
        component: UnableSchedulePage
    },
    {
        title: "Unable To Schedule",
        path: "/emailToSchedule/unableSchedule",
        component: UnableSchedulePage
    },
    {
        title: "No Technician",
        path: "/ResidentScheduleOptimization/EmailToSchedule/noTechnician",
        component: NoTechnicianPage
    },
    {
        title: "TimeApproaching",
        path: "/ResidentScheduleOptimization/EmailToSchedule/timeApproaching",
        component: TimeApproachingPage
    },
    {
        title: "Schedule Your Visit",
        path: "/SuperintendentBooking/Booking",
        component: SuperintendentBookingPage
    },
];
export var residentScheduleOptimizationList = [
    {
        title: "EmailToSchedule",
        path: "/ResidentScheduleOptimization/EmailToSchedule",
        component: ResidentEmailToSchedule,
        titleBar: 'Email To Schedule',
    },
    {
        title: "ResidentEmailScheduleSuccess",
        path: "/ResidentScheduleOptimization/EmailToSchedule/success",
        component: ResidentEmailScheduleSuccess,
    },
];
